import { makeStyles } from "@material-ui/core/styles";

const COLUMN_WIDTH = 420;

export const useStyles = makeStyles((theme) => ({
  column: {
    width: COLUMN_WIDTH,
    maxWidth: "100%",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    paddingTop: theme.spacing(3),
  },
  filterField: {
    backgroundColor: theme.palette.background.paper,
  },
  devicePlaceholder: {
    color: theme.palette.text.disabled,
  },
  reviewCard: {
    marginTop: theme.spacing(1),
  },
  stateBox: {
    textAlign: "center",
    padding: theme.spacing(6, 2),
  },
}));
